import { Link } from "react-router-dom";
import { Wapper, Container, Social, Coppyright } from "./style";
import Intargram from "../../../../assets/img/Langding/Intargram.svg";
import FaceBook from "../../../../assets/img/Langding/FaceBook.svg";
import Twiter from "../../../../assets/img/Langding/Twiter.svg";
import Youtube from "../../../../assets/img/Langding/Youtube.svg";
import Telegram from "../../../../assets/img/Langding/Telegram.svg";
import copyright from "../../../../assets/img/Langding/copyright.svg";

const Foodter = () => {
  return (
    <>
      <Wapper>
        <Container>
          <div>
            <h3>ABOUT</h3>
            <p>About us</p>
            <p>Whitepaper</p>
            <p>Why choose us</p>
          </div>
          <div>
            <h3>C-FOOTPRINT</h3>
            <p>Carbon footprint impact</p>
            <p>Carbon Certificate </p>
          </div>
          <div>
            <h3>OUR IMPACT</h3>
            <p>Our Goals</p>
            <p>Our Impacts</p>
          </div>
          <div>
            <h3>Re-Fi</h3>
          </div>
          <div>
            <div>
              <h3>SUBSCRIBE</h3>
              <p>Stay up to date!</p>
            </div>
            <div>
              <input></input>
              <button>SUBSCRIBE</button>
            </div>
          </div>
          <h3>JOIN THE COMMUNITY</h3>
          <Social>
            <Link to="/">
              <img src={Intargram} alt="" />
            </Link>
            <Link to="/">
              <img src={FaceBook} alt="" />
            </Link>
            <a href=" https://twitter.com/green_tripx?s=21" target="_blank">
              <img src={Twiter} alt="" />
            </a>
            <Link to="/">
              <img src={Youtube} alt="" />
            </Link>
            <a href="https://t.me/GreenFoundationchannel" target="_blank">
              <img src={Telegram} alt="" />
            </a>
          </Social>
        </Container>
      </Wapper>
      <Coppyright>
        <img src={copyright} alt="" />
        <p>2023 GREEN Foundation. All Rights Reserved</p>
      </Coppyright>
    </>
  );
};
export default Foodter;
